<template>
  <section class="page-inbound designNotFound" :class="{ 'rtl': locale === 'ar' }">
    <section class="stepQuote">
      <div class="containerMini">
        <Logo @click="$emit('clickLogo')">
          <template v-if="$slots['logo-first-line']" #logo-first-line>
            <slot name="logo-first-line"></slot>
          </template>

          <template v-if="$slots['logo-second-line']" #logo-second-line>
            <slot name="logo-second-line"></slot>
          </template>
        </Logo>
        <section class="boxForm mt100">
          <div class="containerMini">
            <div class="pageNotFound_content">
              <h1>
               {{ $t('qic_not_found_line1') }} {{ $t('qic_not_found_line2') }}
              </h1>
              <div class="imageStick">
                <img :src="img" alt="personal accident 404">
              </div>
              <router-link :to="{ name: 'Home', params: { locale: locale } }" class="btnSecond">
                {{ $t('qic_error_go_home') }}
              </router-link>
            </div>
          </div> <!-- containerMini-->
        </section> <!--pageNotFound-->
      </div>
    </section>
    <ContactUs  @click="showNeedHelpPopup()" />
    <ContactUsPopup v-model="needHelp" :excluded-countries="excludedCountreis">
      <template v-if="$slots['privacy-policy']" #privacy-policy>
        <slot name="privacy-policy"></slot>
      </template>
    </ContactUsPopup>
  </section> <!-- page inbound-->
</template>

<script>
import Logo from './Logo.vue'
import ContactUs from './need-help/ContactUs.vue'
import ContactUsPopup from './need-help/ContactUsPopup.vue'
export default {
  name: 'BaseNotFound',
  props: ['img', 'text', 'excludedCountreis'],
  components: {
    Logo,
    ContactUs,
    ContactUsPopup
  },
  computed: {
    locale () {
      if (!this.$i18n.locale) return 'en'
      return this.$i18n.locale
    }
  },
  data () {
    return {
      needHelp: false
    }
  },
  methods: {
    showNeedHelpPopup () {
      this.needHelp = true
    }
  }
}
</script>
